export const PRIVACY_POLICY = ''
export const TERMS_OF_USE = ''
